import type { ReactNode } from "react";
import { ApiClientError } from "@/lib/types";
import { useLocale } from "@/locale/LocaleContext";
import { StatePanel } from "./StatePanel";

export function AuthStatePanels({
  loading,
  error,
  loadingTitle,
  children,
  empty,
}: {
  loading: boolean;
  error: ApiClientError | null;
  loadingTitle?: string;
  empty?: ReactNode;
  children: ReactNode;
}) {
  const { m } = useLocale();
  if (loading) return <StatePanel kind="pending" title={loadingTitle ?? m.common.loading} />;
  if (error?.status === 401) {
    return (
      <StatePanel
        kind="unauthenticated"
        title={m.states.sessionEnded}
        message={error.message || m.states.sessionEndedBody}
        actionLabel={m.common.signIn}
        onAction={() => {
          window.location.href = "/login";
        }}
      />
    );
  }
  if (error?.status === 403) {
    return (
      <StatePanel
        kind="forbidden"
        title={m.states.forbidden}
        message={error.message || m.states.forbiddenBody}
      />
    );
  }
  if (error) {
    return <StatePanel kind="error" title={m.states.loadFailed} message={error.message} detail={error.requestId} />;
  }
  if (empty) return empty;
  return children;
}
